<template>
  <div>
    <vs-tabs alignment="fixed">
      <vs-tab :label="'Functionnality'">
        <div>
          <h4 class="mb-4">Setting</h4>
          <BusinessSelectFilterAll
            :multiselect="true"
            v-on:selectBusiness="filterByBuisiness"
            @selectChangeAll="fillItems"
          ></BusinessSelectFilterAll>

          <vs-select
            class="w-100 mb-2 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.Status')"
            v-model="promptData.status"
          >
            <vs-select-item
              :value="0"
              :text="$t('Kiosk.AddKioskPrompt.StatusInactive')"
            />
            <vs-select-item
              :value="1"
              :text="$t('Kiosk.AddKioskPrompt.StatusActive')"
            />
          </vs-select>

          <h4 class="mb-4 mt-4">Functionalities</h4>
          <vs-row>
            <vs-col vs-w="6">
              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.printTicket"
                checked
              >
                {{ $t("Kiosk.AddKioskPrompt.PrintTicket") }}
              </vs-checkbox>

              <div
                class="ticket-sty"
                v-if="promptData.printTicket"
                style="
                        border: 1px solid #888;
                        padding: 10px;
                        border-radius: 5px;
                      "
              >
                <input
                  type="radio"
                  id="one"
                  :value="'Long'"
                  v-model="promptData.ticket_style"
                />
                <label for="one" style="margin-left: 10px">
                  {{ $t("Kiosk.AddKioskPrompt.LongTicket") }}
                </label>
                <br />
                <input
                  type="radio"
                  id="two"
                  :value="'Short'"
                  v-model="promptData.ticket_style"
                />
                <label for="two" style="margin-left: 10px">
                  {{ $t("Kiosk.AddKioskPrompt.ShortTicket") }}
                </label>
              </div>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.smsTicket"
                checked
              >
                {{ $t("Kiosk.AddKioskPrompt.SMSTicket") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowBooking"
              >
                {{ $t("Kiosk.AddKioskPrompt.AllowBooking") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowQueue"
              >
                {{ $t("New.allowQueue") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowMultipleServices"
              >
                {{ $t("Kiosk.AddKioskPrompt.allowMultipleServices") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowQuantityServices"
              >
                {{ $t("Kiosk.AddKioskPrompt.allowQuantityServices") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.collectDetails"
              >
                {{ $t("Kiosk.AddKioskPrompt.CollectCustomerDetails") }}
              </vs-checkbox>
            </vs-col>
            <vs-col vs-w="6">
              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.require_internal_id"
              >
                {{ $t("Kiosk.AddKioskPrompt.RequireInternalId") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.should_print"
              >
                {{ $t("Kiosk.AddKioskPrompt.ShouldPrint") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.show_keyboard"
              >
                {{ $t("Kiosk.AddKioskPrompt.ShowKeyboard") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.loginRequired"
              >
                {{ $t("Kiosk.AddKioskPrompt.GuestLogin") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.multi_language"
              >
                Multi languages
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowTxtQte"
              >
                {{ "Modify quantity services text" }}
              </vs-checkbox>

              <div v-if="promptData.allowTxtQte">
                <vs-textarea
                  :label="'Services quantity text'"
                  rows="5"
                  v-model="promptData.quantityText"
                  class="w-100 mb-2"
                />
              </div>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowPrintWebsocket"
              >
                {{ $t('Kiosk.AddKioskPrompt.PrintWebsocket') }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.displayPhonenumberMessage"
              >
                {{ $t('Kiosk.AddKioskPrompt.displayPhonenumberMessage') }}
              </vs-checkbox>
            </vs-col>
          </vs-row>

          <div
            class="ticket-sty mt-3"
            style="
                        border: 1px solid #888;
                        padding: 10px;
                        border-radius: 5px;
                      "
          >
            <b>Language par defaut: </b><br />
            <input
              type="radio"
              id="onee"
              :value="'fr'"
              v-model="promptData.default_language"
            />
            <label for="onee" style="margin-left: 10px">
              Francais
            </label>
            <br />
            <input
              type="radio"
              id="twoo"
              :value="'en'"
              v-model="promptData.default_language"
            />
            <label for="twoo" style="margin-left: 10px">
              Anglais
            </label>
            <br />
            <input
              type="radio"
              id="threee"
              :value="'ar'"
              v-model="promptData.default_language"
            />
            <label for="threee" style="margin-left: 10px">
              Arabe
            </label>
          </div>

          <vs-select
            class="w-100 mb-2 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.GuestPseudo')"
            v-model="promptData.pseudo"
            v-if="promptData.loginRequired == 0"
          >
            <vs-select-item :value="1" :text="$t('Kiosk.Pseudos.Customer')" />
            <vs-select-item :value="2" :text="$t('Kiosk.Pseudos.Patient')" />
            <vs-select-item :value="3" :text="$t('Kiosk.Pseudos.User')" />
          </vs-select>

          <vs-row>
            <vs-col vs-w="6">
              <vs-input
                :label="$t('Kiosk.AddKioskPrompt.IpAddress')"
                v-model="promptData.ip_address"
                class="w-100 mb-2"
              />
            </vs-col>
            <vs-col vs-w="6">
              <vs-input
                :label="$t('Kiosk.AddKioskPrompt.MacAddress')"
                v-model="promptData.mac_address"
                class="w-100 mb-2"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>

      <vs-tab :label="'Appearance'">
        <div>
          <vs-row class="mb-2 mt-2">
            <vs-col vs-w="6">
              <vs-select
                style="width: 100%"
                class="mb-2 mt-2"
                :label="$t('Kiosk.AddKioskPrompt.Theme')"
                v-model="promptData.theme"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in themes"
                />
              </vs-select>
            </vs-col>

            <vs-col vs-w="5">
              <label class="vs-select--label mt-2">{{
                $t("Kiosk.AddKioskPrompt.Zoom")
              }}</label>
              <br />
              <vs-input-number
                style="margin: 0px 15px"
                size="large"
                :max="100"
                :min="20"
                v-model="promptData.zoom"
              />
            </vs-col>
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label w-50 mb-2 mt-2"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryDark") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultPrimary">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultPrimary"
              v-model="promptData.primary"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label mt-2 mb-2 w-50"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryMedium") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultSecondary">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultSecondary"
              v-model="promptData.secondary"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label mt-2 mb-2 w-50"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryLight") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultSuccess">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultSuccess"
              v-model="promptData.success"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label class="vs-input--label mt-2 w-50" for="color-add-edit">{{
              $t("Kiosk.AddKioskPrompt.Colors.Secondary")
            }}</label>
            <vs-checkbox class="w-25 mt-2" v-model="defaultDanger">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultDanger"
              v-model="promptData.danger"
              type="color"
              name=""
              value=""
              class="w-15 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label w-50 mb-2 mt-2"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.Info") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultInfo">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultInfo"
              v-model="promptData.info"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-input
            type="file"
            class="w-100 mb-2 mt-2"
            id="fileInput"
            :label="$t('Kiosk.AddKioskPrompt.Photo')"
            v-model="promptData.photo"
          />
          <vs-input
            :label="$t('Kiosk.AddKioskPrompt.imagePath')"
            v-model="promptData.imagePath"
            class="w-100 mb-2 mt-3"
          />
        </div>
      </vs-tab>
      <vs-tab :label="'Kiosk V2'">
        <div>
          <vs-row class="m-2 pt-3">
            <vs-col vs-w="6">
              <h6>Config Kiosk v2</h6>
            </vs-col>
            <vs-col vs-w="6">
              <vs-row>
                <label for="">Activate V2 styling</label>
                <vs-switch color="primary" v-model="displayConfigV2" />
              </vs-row>
            </vs-col>
          </vs-row>

          <div v-if="displayConfigV2">
            <vs-row class="ml-1">
              <vs-col vs-w="6">
                <vs-select
                style="width: 100%"
                class="mb-2 mt-2"
                :label="$t('Kiosk.AddKioskPrompt.Theme')"
                v-model="config_v2.theme"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in themesV2"
                />
              </vs-select>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.primaryColor") }}</label
                  >
                  <input
                    v-model="config_v2.primaryColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.secondaryColor") }}</label
                  >
                  <input
                    v-model="config_v2.secondaryColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br>
                  <br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.textColor") }}</label
                  >
                  <input
                    v-model="config_v2.textColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-1 ml-3"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t("KioskConfig_v2.IdleTimeout") }}</label
                  >
                  <input
                    v-model="config_v2.IdleTimeout"
                    type="number"
                    style="width: 28%"
                    class="mb-2 mt-2 ml-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{$t("KioskConfig_v2.services.Title")}}</h4>
               
                <vs-row>
                <label for="">{{ backgroundServiceImage ? "Image" : "Color" }}</label>
                <vs-switch color="primary" v-model="backgroundServiceImage" />
              </vs-row>
              <div v-if="backgroundServiceImage">
                <vs-input
                  type="file"
                  class="w-100 mt-2"
                  id="servicesBackground"
                  :label="$t('KioskConfig_v2.services.background')"
                  @change="updateConfigBackground"
                />
                <!-- <span class="text-primary mt-3" v-if="config_v2.services.background" @click="checkExistingImage('backgroundService')">display image</span> -->
                </div>
                <vs-row class="ml-2" v-else>
                  <label
                    class="vs-input--label mb-2 mt-2"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.background') }}</label
                  >
                  <input
                    v-model="config_v2.services.background"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2 text-primary"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.titleColor') }}</label
                  >
                  <input
                    v-model="config_v2.services.titleColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row>
                <label for="">{{ servicesServiceBackgroundImage ? "Image" : "Color" }}</label>
                <vs-switch color="primary" v-model="servicesServiceBackgroundImage" />
                </vs-row>
              <div v-if="servicesServiceBackgroundImage">
                <vs-input
                  type="file"
                  class="w-100 mt-2"
                  id="servicesServiceBackground"
                  :label="$t('KioskConfig_v2.services.serviceBackground')"
                  @change="updateServiceBackground"
                />
                <!-- <span class="text-primary mt-3" v-if="config_v2.services.serviceBackground" @click="checkExistingImage('servicesServiceBackground')">display image</span> -->
                </div>
                <vs-row class="ml-2" v-else>
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{$t('KioskConfig_v2.services.serviceBackground')}}</label
                  >
                  <input
                    v-model="
                      config_v2.services.serviceBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{$t('KioskConfig_v2.services.serviceTextColor')}}</label
                  >
                  <input
                    v-model="config_v2.services.serviceTextColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-col class="mb-3">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 70%; margin-left: 8px;"
                    >{{$t('KioskConfig_v2.services.selectedServiceBackgroundColor')}}</label
                  >

                  <input
                    v-model="
                      config_v2.services
                        .selectedServiceBackgroundColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.selectedServiceTextColor') }}</label
                  >
                  <input
                    v-model="
                      config_v2.services.selectedServiceTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-4"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.mainButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.services.mainButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-2"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.services.mainButtonTextColor') }}</label
                  >
                  <input
                    v-model="
                      config_v2.services.mainButtonTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.booking.Title') }}</h4>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.background') }}</label
                  >
                  <input
                    v-model="config_v2.booking.background"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.titleColor') }}</label
                  >
                  <input
                    v-model="config_v2.booking.titleColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.subColor') }}</label
                  >
                  <input
                    v-model="config_v2.booking.subColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.textColor') }}</label
                  >
                  <input
                    v-model="config_v2.booking.textColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.booking.calendarBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarSlotBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.booking.calendarSlotBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-4"
                  />
                </vs-row>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.timeSlotBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.booking.timeSlotBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarDayBackgroundColor') }}</label
                  >
                  <input
                    v-model="
                      config_v2.booking
                        .calendarDayBackgroundColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>
                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.booking.calendarButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.booking.calendarButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>
                </vs-col>


                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.header.Title') }}</h4>

               
                  <vs-checkbox
                    class="justify-content-start w-100 mb-2 mt-2"
                    v-model="config_v2.header.showHeader"
                  >
                  {{ $t('KioskConfig_v2.header.showHeader') }}
                  </vs-checkbox>
                  <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.header.headerBackground') }}</label
                  >
                  <input
                    v-model="config_v2.header.headerBackground"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                  <vs-input
                    type="file"
                    class="w-100 mt-2"
                    id="updateheaderLogo"
                    :label="$t('KioskConfig_v2.header.logo')"
                    v-model="headerLogo"
                    @change="updateheaderLogo"
                  />
                  <!-- <span class="text-primary mt-3" v-if="config_v2.header.logo" @click="checkExistingImage('logoHeader')">display image</span> -->
                  <vs-checkbox
                    class="justify-content-start w-100 mb-2 mt-2"
                    v-model="config_v2.header.showHeader"
                  >
                  {{ $t('KioskConfig_v2.header.showHeader') }}
                  </vs-checkbox>
       
                <!--  -->
              </vs-col>
              <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.ticket.Title') }}</h4>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.textColor') }}</label
                  >
                  <input
                    v-model="config_v2.printTicket.textColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.secondaryTextColor') }}</label
                  >
                  <input
                    v-model="
                      config_v2.printTicket.secondaryTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-input
                  type="file"
                  class="w-100 mt-2"
                  id="updatePrintTicketBackgroundImage"
                  :label="$t('KioskConfig_v2.ticket.backgroundImage')"
                  v-model="printTicketBackgroundImage"
                  @change="updatePrintTicketBackgroundImage"
                />
                <!-- <div v-if="!PrintTicketBackgroundImageDeleted && config_v2.printTicket.backgroundImage">
                <span class="text-primary mt-3" @click="checkExistingImage('backgroundImagePrint')">display image</span>
                <span class="text-danger ml-3 mt-3" @click="deletePrintTicketBackgroundImage">X</span>
                </div> -->
                
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.background') }}</label
                  >
                  <input
                    v-model="config_v2.printTicket.background"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.anonButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.printTicket.anonButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.sendButtonTextColor') }}</label
                  >
                  <input
                    v-model="
                      config_v2.printTicket.sendButtonTextColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.backgroundTicketHeader') }}</label
                  >
                  <input
                    v-model="
                      config_v2.printTicket.backgroundTicketHeader
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.ticketHeaderTitle') }}</label
                  >
                  <input
                    v-model="
                      config_v2.printTicket.ticketHeaderTitle
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.ticket.printTicketTimeout') }}</label
                  >
                  <input
                    v-model="
                      config_v2.printTicket.printTicketTimeout
                    "
                    type="number"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>
                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.numpad.Title') }}</h4>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.numBackground') }}</label
                  >
                  <input
                    v-model="config_v2.numPad.numBackground"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.numPrimary') }}</label
                  >
                  <input
                    v-model="config_v2.numPad.numPrimary"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.numSecondary') }}</label
                  >
                  <input
                    v-model="config_v2.numPad.numSecondary"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>

                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.anonymSendButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.numPad.anonymSendButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-col >
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.anonymSendButtonColor') }}</label
                  >
                  <input
                    v-model="
                      config_v2.numPad.anonymSendButtonColor
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-col>

                
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.sendButtonBackground') }}</label
                  >
                  <input
                    v-model="
                      config_v2.numPad.sendButtonBackground
                    "
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2 ml-2"
                  />
           

                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.numpad.sendButtonColor') }}</label
                  >
                  <input
                    v-model="config_v2.numPad.sendButtonColor"
                    type="color"
                    style="width: 15%"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>

                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.footer.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-2"
                  v-model="config_v2.footer.showFooter"
                >
                {{ $t('KioskConfig_v2.footer.showFooter') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.footer.footerBackground') }}</label
                  >
                  <input
                    v-model="config_v2.footer.footerBackground"
                    type="text"
                    class="mb-2 mt-2"
                  />
                </vs-row>
                </vs-col>


                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.onServiceSelect.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-2"
                  v-model="config_v2.onServiceSelect.status"
                >
                {{ $t('KioskConfig_v2.onServiceSelect.Status') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2 mt-4">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.onServiceSelect.Timeout') }}</label
                  >
                  <input
                    v-model="config_v2.onServiceSelect.timeout"
                    type="number"
                    min="2000"
                    step="1000"
                    class="mb-2 mt-2"
                  />
                </vs-row>
              </vs-col>


                <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.onPrintTicket.Title') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-2"
                  v-model="config_v2.onPrintTicket.status"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <br><br><br>
                <vs-row class="ml-2 mt-4">
                  <label
                    class="vs-input--label mb-2 mt-2"
                    for="color-add-edit"
                    style="width: 50%"
                    >{{ $t('KioskConfig_v2.onPrintTicket.Timeout') }}</label
                  >
                  <input
                    v-model="config_v2.onPrintTicket.timeout"
                    type="number"
                    min="2000"
                    step="1000"
                    class="mb-2 mt-2"
                  />
                </vs-row>
              </vs-col>


              <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.anonymousHibernateInterval.Title') }}</h4>

                <vs-checkbox
                    class="justify-content-start w-100 mb-2 mt-2"
                    v-model="config_v2.anonymousHibernateInterval.status"
                >
                  {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
              </vs-col>
              <vs-col vs-w="6">
                <br><br><br>
                <vs-row class="ml-2 mt-4">
                  <label
                      class="vs-input--label mb-2 mt-2"
                      for="color-add-edit"
                      style="width: 50%"
                  >{{ $t('KioskConfig_v2.anonymousHibernateInterval.Timeout') }}</label
                  >
                  <input
                      v-model="config_v2.anonymousHibernateInterval.timeout"
                      type="number"
                      min="2000"
                      step="1000"
                      class="mb-2 mt-2"
                  />
                </vs-row>
              </vs-col>

              <vs-col vs-w="6">
                <h4 class="mb-4 mt-4 text-primary">{{ $t('KioskConfig_v2.allowPagination') }}</h4>

                <vs-checkbox
                  class="justify-content-start w-100 mb-2 mt-2"
                  v-model="config_v2.allowPagination"
                >
                {{ $t('KioskConfig_v2.onPrintTicket.Status') }}
                </vs-checkbox>
                </vs-col>
            </vs-row>

          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    <vs-row class="ml-1 mt-3">
      <vs-col vs-w="4">
        <vs-button color="primary" @click="editKioskAll()" class="w-100 mb-2">{{
          $t("Kiosk.AddKioskPrompt.SubmitButton")
        }}</vs-button>
      </vs-col>
    </vs-row>
    <!---Show Sectet --->
    <vs-prompt
      color="success"
      :active.sync="createShowSecret"
      :title="$t('Kiosk.ShowSecretPrompt.Title')"
      :cancel-text="$t('Kiosk.ShowSecretPrompt.CancelButton')"
      buttonAccept="false"
    >
      <div>
        <div class="mb-4">
          <h4 class="font-weight-light">
            {{ $t("Kiosk.ShowSecretPrompt.Key") }}
          </h4>
          <h3 class="mt-2">{{ createKeyValue }}</h3>
        </div>

        <div class="mb-4">
          <h4 class="font-weight-light">
            {{ $t("Kiosk.ShowSecretPrompt.Secret") }}
          </h4>
          <h3 class="mt-2 mb-2">{{ createSecretValue }}</h3>
          <span class="text-danger mt-2">{{
            $t("Kiosk.ShowSecretPrompt.SecretSave")
          }}</span>
        </div>

        <div class="mb-4">
          <h4 class="font-weight-light">
            {{ $t("Kiosk.ShowSecretPrompt.Token") }}
          </h4>
          <vs-input v-model="createTokenValue" disabled class="w-100" />
          <span class="text-danger mt-2">{{
            $t("Kiosk.ShowSecretPrompt.TokenSave")
          }}</span>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { businessService } from "../../_services";
import BusinessSelectFilterAll from "../shared/BusinessSelectFilterAll";
import router from "../../_helpers/router";
// moment

export default {
  name: "EditKioskAll",
  data: () => ({
    title: "EditKioskAll",
    createShowSecret: false,
    createSecretValue: "",
    createKeyValue: "",
    createTokenValue: "",
    promptData: {
      multi_language: true,
      default_language: "fr",
      name: "",
      photo: "",
      photoDelete: false,
      theme: "liberrex",
      status: 1,
      printTicket: 1,
      smsTicket: "Long",
      ticket_style: "1",
      allowBooking: 0,
      allowQueue: 1,
      allowMultipleServices: 1,
      allowQuantityServices: 0,
      allowTxtQte: 0,
      quantityText: `{"en": "", "fr": "", "ar": ""}`,
      allowPrintWebsocket: false,
      displayPhonenumberMessage: false,
      imagePath: "",
      collectDetails: 0,
      agencies: [],
      ip_address: "",
      mac_address: "",
      require_internal_id: 0,
      should_print: 0,
      show_keyboard: 0,
      loginRequired: 0,
      pseudo: 0,
      primary: "",
      secondary: "",
      success: "",
      danger: "",
      zoom: 100,
      info: "",
    },
    defaultInfo: true,
    errors: {
      name: false,
      queues: false,
      agencies: false
    },
    defaultPrimary: true,
    defaultSecondary: true,
    defaultSuccess: true,
    defaultDanger: true,
    defaultEditPrimary: false,
    defaultEditSecondary: false,
    defaultEditSuccess: false,
    defaultEditDanger: false,
    config_v2: {
      theme: "firstTheme",
      primaryColor: "#244578",
      secondaryColor: "#F39800",
      textColor: "#FFFFFF",
      IdleTimeout: 600000,
      services: {
        background: null,
        titleColor: "#FFFFFF",
        serviceBackground: "#FFFFFF",
        serviceTextColor: "#244578",
        selectedServiceBackgroundColor: "#F39800",
        selectedServiceTextColor: "#FFFFFF",
        mainButtonBackground: "#E9E4E1",
        mainButtonTextColor: "#244578",
      },
      booking: {
        background: "#E9E4E1",
        titleColor: "#244578",
        subColor: "#B3B0AD",
        textColor: "#FFFFFF",
        calendarBackground: "#FFFFFF",
        calendarSlotBackground: "#244578",
        timeSlotBackground: "#F39800",
        calendarDayBackgroundColor: "#244578",
        calendarButtonBackground: "#F39800",
      },
      header: {
        showHeader: true,
        headerBackground: "#FFFFFF",
        logo: null,
        borderRadius: true,
      },
      printTicket: {
        textColor: "#244578",
        secondaryTextColor: "#F39800",
        backgroundImage: null,
        background: "#E9E4E1",
        anonButtonBackground: "#F39800",
        sendButtonTextColor: "#244578",
        printTicketTimeout: 2000,
      },
      numPad: {
        numBackground: "#FFFFFF",
        numPrimary: "#244578",
        numSecondary: "#F39800",
        anonymSendButtonBackground: "#244578",
        anonymSendButtonColor: "#FFFFFF",
        sendButtonBackground: "#E9E4E1",
        sendButtonColor: "#244578",
      },
      footer: {
        showFooter: true,
        footerBackground: "rgba(0, 0, 0, 0.35)",
      },
      onServiceSelect: {
        status: false,
        timeout: null
      },
      onPrintTicket: {
        status: false,
        timeout: null
      },
      anonymousHibernateInterval: {
        status: true,
        timeout: 30000
      },
      allowPagination: false,
      backgroundTicketHeader: '',
      ticketHeaderTitle: ''
    },
    backgroundServiceImage: true,
    servicesServiceBackgroundImage: true,
    printTicketBackgroundImage: null,
    headerLogo: null,
    servicesBackground: null,
    displayConfigV2: false,
    changeAll: false,
    items: []
  }),
  components: {
    BusinessSelectFilterAll,
  },
  props: {
    queues: Array,
    themes: Array,
    themesV2: Array,
  },
  methods: {
    fillItems(items, checkValue) {
      this.items = items;
      this.changeAll = checkValue;
    },
    filterByBuisiness(selected, checkValue) {
      this.reloadComponents = true;
      this.promptData.agencies = selected.map((obj) => {
        return obj.id;
      });
      this.$nextTick(() => {
        this.reloadComponents = false;
      });
      this.changeAll = checkValue;
    },
    updateServiceBackground() {
      if (
        document.getElementById("servicesServiceBackground") &&
        document.getElementById("servicesServiceBackground").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("servicesServiceBackground").files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.config_v2.services.serviceBackground = rawImg;
        };
        reader.readAsDataURL(file);
      }
    },
    updateConfigBackground() {
      if (
        document.getElementById("servicesBackground") &&
        document.getElementById("servicesBackground").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("servicesBackground").files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.config_v2.services.background = rawImg;
        };
        reader.readAsDataURL(file);
      }
    },
    updateheaderLogo() {
      if (
        document.getElementById("updateheaderLogo") &&
        document.getElementById("updateheaderLogo").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("updateheaderLogo").files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.config_v2.header.logo = rawImg;
        };
        reader.readAsDataURL(file);
      }
    },
    updatePrintTicketBackgroundImage() {
      if (
        document.getElementById("updatePrintTicketBackgroundImage") &&
        document.getElementById("updatePrintTicketBackgroundImage").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("updatePrintTicketBackgroundImage")
          .files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.config_v2.printTicket.backgroundImage = rawImg;
        };
        reader.readAsDataURL(file);
      }
    },
    getAllKiosk() {
      this.$emit("refresh_kiosk", "refresh_kiosk");
    },
    sendKeySecret(key, secret, authToken) {
      this.$emit("credentials", {
        key: key,
        secret: secret,
        authToken: authToken,
      });
    },
    editKioskAll() {
      let res = this.validateFields();
      if (!res) {
        return false;
      }
      this.showLoading();

      let kioskData = new FormData();
      if (this.changeAll) {
        kioskData.append(
          "agencies",
          this.items.map((el) => {
            return el.id;
          })
        );
      } else {
        kioskData.append("agencies", this.promptData.agencies.join(","));
      }
      kioskData.append("theme", this.promptData.theme);
      kioskData.append("status", this.promptData.status);
      kioskData.append("ip_address", this.promptData.ip_address);
      kioskData.append("mac_address", this.promptData.mac_address);
      kioskData.append("deletePhoto", this.promptData.photoDelete);
      kioskData.append("allow_booking", this.promptData.allowBooking ? 1 : 0);
      kioskData.append("allow_queue", this.promptData.allowQueue ? 1 : 0);
      kioskData.append(
        "allow_multiple_services",
        this.promptData.allowMultipleServices ? 1 : 0
      );
      kioskData.append(
        "allow_quantity_services",
        this.promptData.allowQuantityServices ? 1 : 0
      );
      kioskData.append(
        "allow_quantity_text",
        this.promptData.allowTxtQte ? 1 : 0
      );
      kioskData.append("quantity_text", this.promptData.quantityText);
      kioskData.append("allow_print_websocket", this.promptData.allowPrintWebsocket ? 1 : 0);
      kioskData.append("display_phonenumber_message", this.promptData.displayPhonenumberMessage ? 1 : 0);
      kioskData.append("image_path", this.promptData.imagePath);
      kioskData.append("print_ticket", this.promptData.printTicket ? 1 : 0);
      kioskData.append("sms_ticket", this.promptData.smsTicket ? 1 : 0);
      kioskData.append("ticket_style", this.promptData.ticket_style);
      kioskData.append(
        "collect_details",
        this.promptData.collectDetails ? 1 : 0
      );
      kioskData.append(
        "require_internal_id",
        this.promptData.require_internal_id ? 1 : 0
      );
      kioskData.append("should_print", this.promptData.should_print ? 1 : 0);
      kioskData.append("show_keyboard", this.promptData.show_keyboard ? 1 : 0);
      kioskData.append("login_required", this.promptData.loginRequired ? 1 : 0);
      kioskData.append("pseudo", this.promptData.pseudo);
      kioskData.append("zoom", this.promptData.zoom);
      kioskData.append("multi_language", this.promptData.multi_language);
      kioskData.append("default_language", this.promptData.default_language);

      if (!this.defaultPrimary) {
        kioskData.append("primary", this.promptData.primary);
      } else if (this.defaultPrimary) {
        kioskData.append("primary", "");
      }
      if (!this.defaultSecondary) {
        kioskData.append("secondary", this.promptData.secondary);
      } else if (this.defaultSecondary) {
        kioskData.append("secondary", "");
      }
      if (!this.defaultSuccess) {
        kioskData.append("success", this.promptData.success);
      } else if (this.defaultSuccess) {
        kioskData.append("success", "");
      }
      if (!this.defaultDanger) {
        kioskData.append("danger", this.promptData.danger);
      } else if (this.defaultDanger) {
        kioskData.append("danger", "");
      }
      if (!this.defaultInfo) {
        kioskData.append("info", this.promptData.info);
      } else if (this.defaultInfo) {
        kioskData.append("info", "");
      }
      // V2 config
      if (!this.displayConfigV2) {
        kioskData.append("config_v2", null);
      } else {
        kioskData.append("config_v2", JSON.stringify( this.config_v2));
      }

      if (
        document.getElementById("fileInput") &&
        document.getElementById("fileInput").files[0]
      ) {
        kioskData.append(
          "photo",
          document.getElementById("fileInput").files[0]
        );
      }
      kioskData.append("_method", "POST");

      businessService
        .updateAgenciesKiosks(kioskData)
        .then(
          function(data) {
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Kiosk.AddKioskPrompt.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Kiosk.AddKioskPrompt.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.close();
            this.hideLoading();
          }.bind(this)
        );
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    validateFields() {
      this.errors.agencies = this.promptData.agencies.length > 0 ? false : true;

      let { agencies } = this.errors;
      return !agencies;
    },
    close() {
      this.$emit("hide", "close");
    },
    showLoading() {
      this.$vs.loading({
        container: "#kiosks-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#kiosks-box > .con-vs-loading");
    },
  },
};
</script>
